export default __webpack_public_path__ + "static/media/Old_devor_stellaj1.f6c73499.png";